/**
 * Contacts Page
 * Main contacts list view - container for ContactList component
 */

import React from "react";
import { Link } from "react-router-dom";
import ContactList from "../components/contacts/ContactList";
import { useAuth } from "../contexts/AuthContext";
import { normalizeRole } from "../utils/roleUtils";

const Contacts: React.FC = () => {
  const { user } = useAuth();
  const isAdmin = ["superadmin", "admin"].includes(normalizeRole(user?.role));

  return (
    <div className="p-6">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Contacts</h1>
          <p className="text-gray-600">Manage your contacts and leads</p>
        </div>
        {isAdmin && (
          <Link
            to="/contacts/attributes"
            className="text-sm text-primary-600 hover:text-primary-800 font-medium"
          >
            Manage Attributes
          </Link>
        )}
      </div>
      <ContactList />
    </div>
  );
};

export default Contacts;
